import React from "react";

import { Stack } from "@mui/material";
import { Info } from "@mui/icons-material";

import { HelpBox } from "@/components/atoms";

type HelpContainerProps = {
  helpText: string;
  children: React.ReactElement<any, any>;
  disabled?: boolean;
};

const HelpContainer: React.FC<HelpContainerProps> = ({
  helpText,
  children,
  disabled = false,
}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {children}
      <HelpBox title={helpText} placement="right">
        <Info fontSize="small" color={disabled ? "disabled" : "info"} />
      </HelpBox>
    </Stack>
  );
};

export default HelpContainer;
